import { render, staticRenderFns } from "./CreateRoomForm.vue?vue&type=template&id=4049130a&scoped=true&"
import script from "./CreateRoomForm.vue?vue&type=script&lang=js&"
export * from "./CreateRoomForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoomForm.vue?vue&type=style&index=0&id=4049130a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4049130a",
  null
  
)

export default component.exports